import React from 'react';

export default function TreeIcon({ size = 'sm', type = 'right', active = false }) {
    return (
        <div className={`dt-tree__icon ${size} ${type} ${active ? 'active' : ''}`}>
            <i className="d-inline-block icon-arrow-right text-light"></i>
        </div>
    );
}
